module.exports = __webpack_public_path__ + "img/ico-prev.862a0016.svg";